const func = require('../_util.js')

let data = (() => {
  const result = []
  for (let index = 0; index < 60; index++) {
    result.push({
      id: 1,
      'projectId|1': ['2010011258', '2010011259'],
      token: '123123123123',
      projectInfo: {
        projectLogo: 'https://dd.jzbull.com/dsx/pc/20210429212812c25b8r7beupd6ebfj15g.jpg',
        'projectName|1': ['@ctitle(5)', '@ctitle(6)']
      }
    })
  }
  return result
})()

const login = {
  // url: '/user/apiUserAh5Service/loginByToken',
  type: 'post',
  response: func.resultSuccess(data.find(item => item.id === 1))
}

const getUserInfo = {
  // url: '/user/apiUserAh5Service/getUserInfo',
  type: 'post',
  response: func.resultSuccess(data.find(item => item.id === 1))
}

module.exports = [login, getUserInfo]
